// data.js

export default {
  text: 'Hello from data.js',
}
